<template>
  <div class="web" v-loading="loading">
    <el-row :gutter="20">
      <!-- 园所预览 -->
      <el-col :span="18" v-if="!editType">
        <div class="school">
          <div class="schoolTitle clearfix">
            <div class="fl">我的园所</div>
            <div class="fr">
              <el-link icon="el-icon-edit" type="primary" @click="editSchool"
                >编辑</el-link
              >
            </div>
          </div>
          <el-divider></el-divider>
          <div class="detailTop">
            <div>
              <el-avatar fit="scale-down" :size="60">
                <img
                  slot="default"
                  :src="schoolForm.avatar"
                  alt=""
                  style="width: 100%"
                />
              </el-avatar>
            </div>
            <div class="detailTopBox">
              <div>{{ schoolForm.name }}</div>
              <div class="detailTopContent">
                <span
                  >{{ schoolForm.province_name ? schoolForm.province_name : ""
                  }}{{ schoolForm.city_name ? schoolForm.city_name : ""
                  }}{{ schoolForm.dist_name ? schoolForm.dist_name : "" }}</span
                >
                <el-divider direction="vertical"></el-divider>
                <span
                  v-if="schoolForm.scale !== undefined && schoolForm.scale"
                  >{{
                    scaleList.filter((o) => o.active === schoolForm.scale)[0]
                      .name
                  }}</span
                >
                <el-divider direction="vertical"></el-divider>
                <span
                  v-if="
                    schoolForm.company_type !== undefined &&
                    schoolForm.company_type
                  "
                  >{{
                    typePicker.filter(
                      (o) => o.active === schoolForm.company_type
                    )[0].name
                  }}</span
                >
              </div>
            </div>
          </div>
          <div
            class="detailBox"
            v-if="
              schoolForm.showLabel !== undefined &&
              schoolForm.showLabel.length > 0
            "
          >
            <div class="detailTitle">福利待遇</div>
            <div class="detailLabel">
              <el-tag
                type="success"
                v-for="(item, index) in schoolForm.showLabel"
                :key="index"
                >{{ item }}</el-tag
              >
            </div>
          </div>
          <div class="detailBox">
            <div class="detailTitle">园所介绍</div>
            <div class="detailText" v-html="schoolForm.desc">
              {{ schoolForm.desc }}
            </div>
          </div>
          <div class="detailBox">
            <div class="detailTitle">园所相册</div>
            <div class="detailText">
              <div
                v-if="
                  schoolForm.photo !== undefined &&
                  schoolForm.photo.length === 0
                "
                class="noPhoto"
              >
                暂无相册
              </div>
              <div v-else>
                <el-carousel indicator-position="none">
                  <el-carousel-item
                    v-for="(item, index) in schoolForm.photo"
                    :key="index"
                  >
                    <el-image
                      style="cursor: pointer"
                      @click="openPhoto(item)"
                      :src="item.url"
                      fit="contain"
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
          <div class="detailBox">
            <div class="detailTitle">营业执照或办园许可证</div>
            <div class="detailText">
              <div
                v-if="
                  schoolForm.require_pic !== undefined &&
                  schoolForm.require_pic.length === 0
                "
                class="noPhoto"
              >
                暂无营业执照或办园许可证
              </div>
              <div v-else>
                <el-image
                  style="width: 200px; height: 200px"
                  v-if="schoolForm.require_pic !== undefined"
                  :src="schoolForm.require_pic[0].url"
                  fit="contain"
                ></el-image>
              </div>
            </div>
          </div>
          <div class="detailBox">
            <div class="detailTitle">园所地址</div>
            <div class="school_address">
              <div class="school_addressTitle">
                <i class="el-icon-location-outline"></i>
                {{ schoolForm.address }}
              </div>
              <Amap />
            </div>
          </div>
        </div>
      </el-col>

      <!-- 编辑园所 -->
      <el-col :span="18" v-if="editType">
        <div class="edit">
          <el-form ref="form" :model="schoolForm" :rules="editRule">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="上传LOGO">
                  <el-upload
                    action=""
                    :file-list="schoolForm.avatar.filter((o) => o.url)"
                    list-type="picture-card"
                    :http-request="avatarFun"
                    :on-remove="
                      (file, fileList) => handleRemove(file, fileList, 'avatar')
                    "
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="园所名称" class="boxHei" prop="name">
                  <el-input class="boxWid" v-model="schoolForm.name" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人" class="boxHei">
                  <div>{{ schoolForm.charge_name }}</div>
                  <div class="editTips" v-if="editType">
                    请去小程序上修改负责人
                  </div>
                  <!-- <el-input class="boxWid" v-model="schoolForm.charge_name" /> -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号码" class="boxHei" prop="mobile">
                  <!-- <el-input class="boxWid" v-model.number="schoolForm.mobile" /> -->
                  <div>{{ schoolForm.mobile }}</div>
                  <div class="editTips">请去小程序上修改手机</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="机构类型" class="boxHei">
                  <el-select
                    class="boxWid"
                    v-model="schoolForm.company_type"
                    placeholder="请选择机构类型"
                  >
                    <el-option
                      v-for="(item, index) in typePicker"
                      :key="index"
                      :label="item.name"
                      :value="item.active"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="园所性质" class="boxHei">
                  <el-select
                    class="boxWid"
                    multiple
                    v-model="schoolForm.quality"
                    placeholder="请选择园所性质"
                  >
                    <el-option
                      v-for="(item, index) in natureList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="园所规模" class="boxHei">
                  <el-select
                    class="boxWid"
                    v-model="schoolForm.scale"
                    placeholder="请选择园所规模"
                  >
                    <el-option
                      v-for="(item, index) in scaleList"
                      :key="index"
                      :label="item.name"
                      :value="item.active"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="福利标签" class="boxHei">
                  <el-select
                    class="boxWid"
                    multiple
                    v-model="schoolForm.label"
                    placeholder="请选择福利标签"
                  >
                    <el-option
                      v-for="(item, index) in labelList"
                      :key="index"
                      :label="item.label_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="园所介绍">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 4 }"
                    placeholder="请输入内容"
                    v-model="schoolForm.desc"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="地址">
                  <el-autocomplete
                    class="boxWid"
                    v-model="schoolForm.address"
                    placeholder="请输入地址"
                    :fetch-suggestions="searchMap"
                    @select="changeAddress"
                  >
                    <template slot-scope="{ item }">
                      <div class="name">
                        {{
                          (item.pname ? item.pname : "") +
                          (item.cityname ? item.cityname : "") +
                          (item.adname ? item.adname : "") +
                          item.name
                        }}
                      </div>
                    </template>
                  </el-autocomplete>
                  <div style="margin-top: 10px">
                    <Amap
                      ref="map"
                      :longitude="schoolForm.longitude"
                      :latitude="schoolForm.latitude"
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <div style="color: #606266">园所相册</div>
                  <el-upload
                    action=""
                    :file-list="schoolForm.photo.filter((o) => o.url)"
                    list-type="picture-card"
                    :http-request="PhotoFun"
                    :on-remove="
                      (file, fileList) => handleRemove(file, fileList, 'photo')
                    "
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <div style="color: #606266">营业执照或办园许可证</div>
                  <el-upload
                    action=""
                    :file-list="schoolForm.require_pic.filter((o) => o.url)"
                    list-type="picture-card"
                    :http-request="BusinessFun"
                    :on-remove="
                      (file, fileList) =>
                        handleRemove(file, fileList, 'require_pic')
                    "
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <div style="text-align: center">
                  <el-button @click="resizeSchool">取消</el-button>
                  <el-button type="primary" @click="schoolSubmit"
                    >保存</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-col>

      <!-- 操作 -->
      <el-col :span="6">
        <div class="operation">
          <div class="schoolTitle clearfix">
            <div class="fl">我的职位</div>
            <div class="fr">
              <el-link
                icon="el-icon-circle-plus-outline"
                type="primary"
                @click="addPost"
                >新增</el-link
              >
            </div>
          </div>
          <el-divider></el-divider>
          <div class="list">
            <div
              class="listBox clearfix"
              v-for="(item, index) in list"
              :key="index"
              @click="goPost(item)"
            >
              <div class="fl">{{ item.job_name }}</div>
              <div class="fr salary_package">
                {{ item.salary_package
                }}{{ item.salary_package === "面议" ? "" : "元/月" }}
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="schoolTitle clearfix">
            <div class="fl">手机查看</div>
          </div>
          <el-divider></el-divider>
          <div class="list">
            <img :src="weChatCode" alt="" class="weChatCode" />
          </div>
        </div>
        <div class="operation">
          <div class="schoolTitle clearfix">
            <div class="fl">收到的简历</div>
            <div class="fr">
              <el-link icon="el-icon-view" type="primary" @click="goReceived"
                >查看更多</el-link
              >
            </div>
          </div>
          <el-divider></el-divider>
          <div class="list">
            <div
              class="receivedList clearfix"
              v-for="(item, index) in receivedList"
              :key="index"
              @click="receivedDetail(item)"
            >
              <div class="fl receivedListBox">
                <div>
                  <el-avatar :size="60" :src="item.avatar"></el-avatar>
                </div>
                <div style="width: 50%">
                  <div class="vita_name textOverflow">{{ item.vita_name }}</div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.job_name"
                    placement="right"
                  >
                    <div class="job_name">
                      {{ item.job_name }}
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <div class="fr salary_package">
                {{ item.ideamoney
                }}{{ item.ideamoney === "面议" ? "" : "元/月" }}
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Amap from "@/components/map";
import { getWeChatCode } from "@/js/common.js";

export default {
  components: {
    Amap,
  },
  watch: {
    editType() {
      if (this.editType) {
        this.schoolForm.desc = this.schoolForm.desc.replace(/<br>/g, "\n");
      } else {
        this.schoolForm.desc = this.schoolForm.desc.replace(/\n/g, "<br>");
        this.schoolForm.desc = this.schoolForm.desc.replace(/↵/g, "<br>");
      }
    },
  },
  data() {
    return {
      weChatCode: "",
      loading: true,
      editType: false,
      schoolForm: {},

      // 规模
      scaleList: [
        {
          active: 1,
          name: "5个班以下",
        },
        {
          active: 2,
          name: "5-10个班",
        },
        {
          active: 3,
          name: "10~15个班",
        },
        {
          active: 4,
          name: "15~20个班",
        },
        {
          active: 5,
          name: "20个班以上",
        },
      ],

      // 机构类型
      typePicker: [
        {
          active: 1,
          name: "幼儿园",
        },
        {
          active: 2,
          name: "早教/托育机构",
        },
        {
          active: 3,
          name: "综合教育公司",
        },
        {
          active: 4,
          name: "其他",
        },
      ],

      //   福利待遇
      labelList: [
        {
          id: "26",
          label_name: "寒暑假",
          label_desc: "寒暑假",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 0,
          label_addTime: 1572340894,
        },
        {
          id: "27",
          label_name: "就读优惠",
          label_desc: "子女入学优惠",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 0,
          label_addTime: 1572340919,
        },
        {
          id: "28",
          label_name: "节日福利",
          label_desc: "节日福利",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 0,
          label_addTime: 1572341156,
        },
        {
          id: "24",
          label_name: " 社保",
          label_desc: "社保",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 1,
          label_addTime: 1559107218,
        },
        {
          id: "23",
          label_name: " 双休",
          label_desc: " 双休",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 2,
          label_addTime: 1559107202,
        },
        {
          id: "22",
          label_name: " 包吃",
          label_desc: "包吃",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 3,
          label_addTime: 1559107192,
        },
        {
          id: "21",
          label_name: "包住",
          label_desc: "包住",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 4,
          label_addTime: 1559107181,
        },
        {
          id: "20",
          label_name: "餐补",
          label_desc: "餐补",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 5,
          label_addTime: 1559106888,
        },
        {
          id: "19",
          label_name: "房补 ",
          label_desc: "房补",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 6,
          label_addTime: 1559106874,
        },
        {
          id: "18",
          label_name: "全勤奖",
          label_desc: "全勤奖",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 10,
          label_addTime: 1559106865,
        },
        {
          id: "17",
          label_name: "年终奖",
          label_desc: "年终奖",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 11,
          label_addTime: 1559106856,
        },
        {
          id: "16",
          label_name: "有提成",
          label_desc: "有提成",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 12,
          label_addTime: 1559106848,
        },
        {
          id: "15",
          label_name: "年度旅游",
          label_desc: "年度旅游",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 16,
          label_addTime: 1559106838,
        },
        {
          id: "14",
          label_name: "五险一金",
          label_desc: "五险一金",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 17,
          label_addTime: 1559106826,
        },
        {
          id: "13",
          label_name: "通讯补贴",
          label_desc: "通讯补贴",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 18,
          label_addTime: 1559106817,
        },
        {
          id: "12",
          label_name: "年底双薪",
          label_desc: "年底双薪",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 19,
          label_addTime: 1559106804,
        },
        {
          id: "11",
          label_name: "年终分红",
          label_desc: "年终分红 ",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 20,
          label_addTime: 1559106782,
        },
        {
          id: "10",
          label_name: "加班补助",
          label_desc: "加班补助",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 21,
          label_addTime: 1559106771,
        },
        {
          id: "9",
          label_name: "带薪年假 ",
          label_desc: "带薪年假 ",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 22,
          label_addTime: 1559106762,
        },
        {
          id: "7",
          label_name: "交通补贴",
          label_desc: "交通补贴",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 24,
          label_addTime: 1559106743,
        },
        {
          id: "6",
          label_name: "高温补贴",
          label_desc: "高温补贴",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 25,
          label_addTime: 1559106735,
        },
        {
          id: "5",
          label_name: "采暖补贴 ",
          label_desc: "采暖补贴 ",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 26,
          label_addTime: 1559106727,
        },
        {
          id: "4",
          label_name: "弹性工作",
          label_desc: "弹性工作",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 27,
          label_addTime: 1559106692,
        },
        {
          id: "3",
          label_name: "医疗保险",
          label_desc: "医疗保险",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 28,
          label_addTime: 1559106683,
        },
        {
          id: "2",
          label_name: "定期体检",
          label_desc: "定期体检",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 29,
          label_addTime: 1559106669,
        },
        {
          id: "25",
          label_name: "免费班车",
          label_desc: "免费班车",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 30,
          label_addTime: 1560596713,
        },
      ],

      //   职位
      list: [],

      //   收到的简历
      receivedList: [],

      //   园所性质
      natureList: [
        {
          id: "0",
          name: "私立园",
          active: false,
        },
        {
          id: "1",
          name: "集团园",
          active: false,
        },
        {
          id: "2",
          name: "集体办园",
          active: false,
        },
        {
          id: "3",
          name: "公办园",
          active: false,
        },
        {
          id: "4",
          name: "省一级示范园",
          active: false,
        },
        {
          id: "5",
          name: "市一级示范园",
          active: false,
        },
        {
          id: "6",
          name: "区一级示范园",
          active: false,
        },
        {
          id: "7",
          name: "新开园",
          active: false,
        },
        {
          id: "8",
          name: "连锁园",
          active: false,
        },
        {
          id: "9",
          name: "连锁机构",
          active: false,
        },
        {
          id: "10",
          name: "新型公办园",
          active: false,
        },
        {
          id: "11",
          name: "其他",
          active: false,
        },
      ],

      editRule: {
        name: [
          { required: true, message: "请输入园所名称", trigger: "blur" },
          { max: 14, message: "园所名称最多14个字", trigger: "blur" },
        ],
        mobile: [{ type: "number", message: "请输入正确的手机" }],
      },

      addressList: [],
    };
  },
  created() {
    this.getDetail();
    this.getReceived();
    this.getPost();
    getWeChatCode(this, "bossjoin/pages/SchoolHomePage/SchoolHomePage", "1");
  },
  methods: {
    // 获取收到的简历
    getReceived() {
      let obj = {
        page: 1,
        size: 5,
      };
      this.api.get("/5cff829aa56af", obj).then((r) => {
        this.receivedList = r.data.list;
      });
    },

    // 获取我的职位
    getPost() {
      let obj = {
        page: 1,
        size: 5,
      };
      this.api.get("/5cef405d39ad5", obj).then((r) => {
        this.list = r.data.list;
      });
    },

    //   获取园所详情
    getDetail() {
      this.loading = true;
      this.api.get("/5cee6525269f6", {}).then((r) => {
        this.loading = false;
        this.schoolForm = r.data;
        if (this.schoolForm.company_type === 0) {
          this.schoolForm.company_type = "";
        }
        if (this.schoolForm.label) {
          this.schoolForm.showLabel = [];
          this.schoolForm.label = JSON.parse(this.schoolForm.label);
          this.labelList.forEach((o) => {
            this.schoolForm.label.forEach((oa) => {
              if (o.id === oa) {
                this.schoolForm.showLabel.push(o.label_name);
              }
            });
          });
        }
        if (this.schoolForm.desc) {
          this.schoolForm.desc = this.schoolForm.desc.replace(/↵/g, "<br>");
          this.schoolForm.desc = this.schoolForm.desc.replace(/\n/g, "<br>");
        }
        if (this.schoolForm.quality) {
          this.schoolForm.quality = JSON.parse(this.schoolForm.quality);
        }
        if (!this.schoolForm.require_pic) {
          this.schoolForm.require_pic = [];
        } else {
          this.schoolForm.require_pic = [
            {
              url: this.schoolForm.require_pic,
            },
          ];
        }
      });
    },

    // 去职位详情
    goPost(o) {
      this.$router.push({
        path: "/boss/postDetail",
        query: {
          jid: o.jid,
        },
      });
    },

    // 新增职位
    addPost() {
      this.$router.push({
        path: "/boss/postDetail",
      });
    },

    // 查看收到的简历
    goReceived() {
      this.$router.push({
        path: "/boss/received",
      });
    },

    // 收到的简历详情
    receivedDetail(o) {
      this.$router.push({
        path: "/boss/resumeDetail",
        query: {
          vid: o.vid,
        },
      });
    },

    // 编辑园所
    editSchool() {
      this.editType = true;
      if (this.schoolForm.avatar) {
        this.schoolForm.avatar = [{ url: this.schoolForm.avatar }];
      } else {
        this.schoolForm.avatar = [];
      }
    },

    // 搜索地图
    searchMap(o, cb) {
      this.$axios({
        method: "get",
        url:
          "https://restapi.amap.com/v3/place/text?key=da434aca7336bc518af0a18daaf9b2da&keywords=" +
          o,
      }).then(function (res) {
        cb(res.data.pois);
      });
    },

    // 选择地址
    changeAddress(o) {
      this.schoolForm.address =
        (o.pname ? o.pname : "") +
        (o.cityname ? o.cityname : "") +
        (o.adname ? o.adname : "") +
        o.name;
      this.schoolForm.latitude = o.location.split(",")[1];
      this.schoolForm.longitude = o.location.split(",")[0];
      this.schoolForm.province_name = o.pname;
      this.schoolForm.city_name = o.cityname;
      this.schoolForm.dist_name = o.adname;

      this.api
        .get("/5ce1f900906b8", {
          latitude: this.schoolForm.latitude,
          longitude: this.schoolForm.longitude,
        })
        .then((r) => {
          this.schoolForm.province = r.data.province.region_id;
          this.schoolForm.city = r.data.city.region_id;
          this.schoolForm.dist = r.data.district.region_id;
        });
      this.$nextTick(() => {
        this.$refs.map.init();
      });
    },

    // 删除相册
    handleRemove(file, fileList, data) {
      this.schoolForm[data] = fileList;
      this.schoolForm[data] = JSON.parse(JSON.stringify(this.schoolForm[data]));
      this.schoolForm[data].push({ id: file.id, url: "" });
    },

    // 上传头像
    avatarFun(f) {
      let obj = {
        file: f.file,
      };
      this.api.uploadf("/5ce7e4f35dc2b", obj).then((r) => {
        this.schoolForm.avatar = [];
        this.schoolForm.avatar.push({
          id: 0,
          url: r.data.fileUrl,
        });
      });
    },

    // 上传相册
    PhotoFun(f) {
      let obj = {
        file: f.file,
      };
      this.api.uploadf("/5ce7e4f35dc2b", obj).then((r) => {
        this.schoolForm.photo.push({
          id: 0,
          url: r.data.fileUrl,
        });
      });
    },

    // 上传营业执照
    BusinessFun(f) {
      let obj = {
        file: f.file,
      };
      this.api.uploadf("/5ce7e4f35dc2b", obj).then((r) => {
        this.schoolForm.require_pic = [];
        this.schoolForm.require_pic.push({
          id: 0,
          url: r.data.fileUrl,
        });
      });
    },

    // 取消修改园所
    resizeSchool() {
      this.editType = false;
      this.getDetail();
    },

    // 打开图片
    openPhoto(o) {
      window.open(o.url);
    },

    // 园所提交
    schoolSubmit() {
      // 5cee8de5c4fcb 编辑
      // 5cee58e424256 新增
      if (this.schoolForm.require_pic) {
        if (typeof this.schoolForm.require_pic === "object") {
          try {
            this.schoolForm.require_pic = this.schoolForm.require_pic[0].url;
          } catch (error) {}
        }
        if (this.schoolForm.avatar.length > 0) {
          this.schoolForm.avatar = this.schoolForm.avatar[0].url;
        } else {
          this.schoolForm.avatar = "";
        }
        this.api
          .post(
            this.schoolForm.sid ? "/5cee8de5c4fcb" : "/5cee58e424256",
            this.schoolForm
          )
          .then((r) => {
            this.$message({
              message: this.schoolForm.sid ? "编辑成功" : "新增成功",
              type: "success",
            });
            this.editType = false;
            this.getDetail();
            let schoolInfo = JSON.parse(this.Cookies.get("schoolInfo"));
            schoolInfo.avatar = this.schoolForm.avatar;
            this.Cookies.set("schoolInfo", JSON.stringify(schoolInfo), {
              expires: 1,
            });
            location.reload();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.school {
  background: white;
  margin-top: 20px;
  padding: 20px;
}
.operation {
  background: white;
  margin-top: 20px;
  padding: 20px;
}
.detailTop {
  > div {
    display: inline-block;
    vertical-align: middle;
  }
  .detailTopBox {
    margin-left: 5px;
    .detailTopContent {
      font-size: 14px;
      padding-top: 5px;
      color: #757575;
    }
  }
}
.detailBox {
  padding-top: 20px;
  .detailTitle {
    border-left: 2px solid #ff5b12;
    padding-left: 10px;
  }
  .detailLabel {
    padding-top: 10px;
    > span {
      margin-right: 10px;
      margin-bottom: 5px;
    }
  }
  .detailText {
    font-size: 14px;
    padding-top: 10px;
    .noPhoto {
      color: #999;
    }
  }
  .school_address {
    margin-top: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    .school_addressTitle {
      padding-left: 25px;
      color: #62687a;
      padding: 13px 15px 11px 35px;
    }
  }
}
.receivedList:last-child {
  margin-bottom: 0;
}
.receivedList {
  padding: 0;
  cursor: pointer;
  margin-bottom: 10px;
  position: relative;
  .receivedListBox:hover {
    .vita_name {
      color: #ff5b12;
    }
  }
  .receivedListBox {
    width: 70%;
    .vita_name {
      max-width: 100px;
    }
    > div {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .salary_package {
    position: absolute;
    right: 0;
    top: 10px;
  }
}
.salary_package {
  color: #ff5b12;
}
.listBox {
  cursor: pointer;
  padding: 5px 10px;
}
.listBox:hover {
  background-color: #f2f5f9;
}

.edit {
  margin-top: 20px;
  background: white;
  padding: 20px;
  .boxWid {
    width: 100%;
  }
  .boxHei {
    height: 81px;
  }
}
.editTips {
  color: red;
}
.job_name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.weChatCode {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/boss/school.vue